import clsx from 'clsx';
import { FC } from 'react';

import {
  FilterHierarchyFieldsGroupOption,
  FilterOption,
  PlpFiltersConditionalProps,
} from 'src/plp/components/PlpFilters/PlpFilters.type';

import { FilterHierarchyField } from './FilterHierarchyField';
import styles from './FilterHierarchyFieldsGroup.module.scss';

type Props = {
  options: FilterHierarchyFieldsGroupOption[];
  currentFilters: FilterOption[];
  subCategoryLabel: string;
  sortAlphabetically?: boolean;
} & PlpFiltersConditionalProps;

export const FilterHierarchyFieldsGroup: FC<Props> = ({
  options,
  currentFilters,
  subCategoryLabel,
  sortAlphabetically = false,
  ...props
}) => {
  const optionsToMap = sortAlphabetically
    ? [...options].sort((a, b) => a.slug.toLowerCase().localeCompare(b.slug.toLowerCase()))
    : options;

  return (
    <div
      className={clsx(styles.rootOptionsGroup, 'wrapper', 'wrapper--checkbox', 'flex flex-col gap-y-1')}
      data-testid="filter-model-list"
    >
      {optionsToMap.map((option) => {
        return (
          <FilterHierarchyField
            option={option}
            key={option.value}
            currentFilters={currentFilters}
            subCategoryLabel={subCategoryLabel}
            {...props}
          />
        );
      })}
    </div>
  );
};
